module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/responsive-table/responsive-table.component.scss
// module id = ./src/app/modules/common-module/components/responsive-table/responsive-table.component.scss
// module chunks = 9